// 平台运行看板

import React, { Component } from "react";
import { Progress, Tooltip, Popover } from "antd";
import { getCityList, equipmentQry } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
import FormCore from "@/components/display/form/formCore";
import moment from "moment";
import PropTypes from "prop-types";
// 图片
import icon1 from "@/assets/img/displayBoard/stationIcon.png";
import icon2 from "@/assets/img/displayBoard/powerboxIcon.png";
import icon3 from "@/assets/img/displayBoard/stubIcon.png";
// 组件
import StubState from "@/pages/displayBoard/stubState";
import ChargSuccess from "@/pages/displayBoard/chargSuccess";
import ElecticalLossBoard from "@/pages/displayBoard/electicalLossBoard";
import ExceptionBoard from "@/pages/displayBoard/exceptionBoard";
// css
import "@/assets/stylus/displayBoard.styl";
// icon
import { RightOutlined, QuestionCircleFilled, QuestionCircleOutlined } from "@ant-design/icons";
// 运营类型
import OprationType from "@/utils/oprationType";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

@connect((state) => state)
class DisplayBoardIndex extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubList;
    this.yunwei = this.props.intl.messages.commonBase;

    this.state = {
      param: {
        cityIds: "",
        provinceIds: "000000", // 默认 000000全国
        date: moment(new Date()).subtract(1, "d").format("YYYY-MM-DD"),
        operationProperty: "",
        operationMode: "",
      },
      equipmentQry: {
        station: 0, // 桩群数量
        powerBox: 0, // 配电柜数量
        stub: 0, // 桩数量
      },
      successRate: "0",
      stubIntactRate: "0",
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  // 页面加载前方法
  componentWillMount() {
    this.setState({
      formConfig: this.initForm(),
    });
    this.getCityList();
    this.getEquipmentQry();
  }

  // 页面加载完成方法
  componentDidMount() {}

  /**
   * 获取充电成功率数字
   */
  getSuccessRate = (value) => {
    console.log(value);
    this.setState({
      successRate: value,
    });
  };

  /**
   * 获取设备完好率数字
   */
  getStubIntactRate = (value) => {
    this.setState({
      stubIntactRate: value,
    });
  };

  /**
   * 获取设备数据
   */
  getEquipmentQry() {
    fetchHandler(equipmentQry, {
      startTime: this.state.param.date,
      cityIds: this.state.param.cityIds,
      operationMode: this.state.param.operationMode,
      operationProperty: this.state.param.operationProperty,
      provinceIds: this.state.param.provinceIds,
    }).then((res) => {
      console.log(res);
      if (res.data) {
        this.setState({
          equipmentQry: {
            station: res.data.stubGroupQuantity,
            powerBox: res.data.powerBoxQuantity,
            stub: res.data.stubQuantity,
          },
        });
      }
    });
  }

  /**
   * 获取城市数据
   */
  getCityList = () => {
    fetchHandler(getCityList).then((res) => {
      if (!res.data) {
        return;
      }
      const fetchPickerOptions = res.data;
      let formatOptionsStr = JSON.stringify(fetchPickerOptions);
      formatOptionsStr = formatOptionsStr.replace(new RegExp("label", "g"), "title");
      formatOptionsStr = formatOptionsStr.replace(new RegExp("value", "g"), "value");
      formatOptionsStr = formatOptionsStr.replace(new RegExp("children", "g"), "children");
      const cityAryy = JSON.parse(formatOptionsStr);
      cityAryy.map((item) => {
        item.key = item.value;
        item.children.map((item2) => {
          item2.key = item2.value;
          delete item2.children; // 删除子区域数据
          return true;
        });
        return true;
      });
      // 初始化城市数据
      this.quanguoCityArry = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];

      // 只能选择城市的方式
      this.quanguoCityNotP = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];
      this.quanguoCityNotP.map((item) => {
        item.disabled = true;
        item.children.map((item1) => {
          item1.disabled = true;
          item1.children.map((item2) => {
            item2.disabled = false;
            return true;
          });
          return true;
        });
        return true;
      });
      // 只能选择省份的数组
      this.quanguoCityNotCity = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];
      this.quanguoCityNotCity.map((item) => {
        item.disabled = true;
        item.children.map((item1) => {
          item1.disabled = false;
          item1.children.map((item2) => {
            item2.disabled = true;
            return true;
          });
          return true;
        });
        return true;
      });
      // 只能选择全国的数组
      this.quanguoCityNotChild = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
          children: JSON.parse(JSON.stringify(cityAryy)),
        },
      ];
      this.quanguoCityNotChild.map((item) => {
        item.disabled = false;
        item.children.map((item1) => {
          item1.disabled = true;
          item1.children.map((item2) => {
            item2.disabled = true;
            return true;
          });
          return true;
        });
        return true;
      });
      // 设置数据
      this.setState(
        {
          quanguoCityArry: [...this.quanguoCityArry],
        },
        () => {
          console.log(this.state.quanguoCityArry);
          this.setState({
            formConfig: this.initForm(),
          });
        },
      );
    });
  };

  changeCityData = (value) => {
    if (value.length === 0) {
      // 设置数据
      this.setState(
        {
          quanguoCityArry: [...this.quanguoCityArry],
        },
        () => {
          this.setState({
            formConfig: this.initForm(),
          });
        },
      );
    }
    if (value.length === 1) {
      let quanguoCityArryCVal = '';
      if (value[0] === "000000") {
        quanguoCityArryCVal = this.quanguoCityNotChild;
      } else if (value[0].charAt(5) === "0" && value[0].charAt(4) === "0" && value[0].charAt(3) === "0" && value[0].charAt(2) === "0") {
        quanguoCityArryCVal = this.quanguoCityNotCity;
      } else {
        quanguoCityArryCVal = this.quanguoCityNotP;
      }
      // 设置数据
      this.setState(
        {
          quanguoCityArry: quanguoCityArryCVal,
        },
        () => {
          this.setState({
            formConfig: this.initForm(),
          });
        },
      );
    }
  };

  /**
   * 新开tab页方法
   */
  openTab = (param, e) => {
    this.props.onAdd(e, param);
  };

  // 加载form方法
  initForm() {
    const oprationTypeObject = OprationType();
    const option1 = oprationTypeObject.option1;
    const option2 = oprationTypeObject.option2;
    const option3 = oprationTypeObject.option3;

    // 长度设置
    let dropdownMatchSelectWidth;
    if (this.props.intl.locale === "zh") {
      dropdownMatchSelectWidth = true;
    } else if (this.props.intl.locale === "en") {
      dropdownMatchSelectWidth = 200;
    } else {
      dropdownMatchSelectWidth = 250;
    }
    const formConfig = {
      childItems: [
        {
          type: "treeSelect",
          placeholder: "请选择地区",
          param: {
            name: "cityGroup",
            type: "array",
          },
          onChange: this.changeCityData,
          data: this.state.quanguoCityArry,
          treeCheckable: true,
          treeCheckStrictly: false,
          showCheckedStrategy: "SHOW_PARENT",
          labelName: "地区",
          required: false,
        },
        {
          type: "inputGroup",
          isArray: true,
          inputGroup: [
            {
              type: "select",
              width: "95px",
              options: [
                {
                  text: this.yunwei.wz10, // '全部',
                  value: "",
                },
                {
                  text: this.yunwei.wz1, // '运营',
                  value: "1",
                },
                {
                  text: this.yunwei.wz2, // '运维',
                  value: "0",
                },
              ],
              placeholder: this.internationalization.title8, // '请选择',
              param: {
                name: "operationProperty",
                type: "string",
              },
              labelName: this.yunwei.wz0, // '运营类型:',
              required: false,
              onChange: (value, form) => {
                form.setFieldsValue({
                  operationProperty: value,
                  operationMode: "",
                });
                const stubType2List = [];
                if (value === "0") {
                  stubType2List.push(...option2);
                } else if (value === "1") {
                  stubType2List.push(...option1);
                } else if (value === "") {
                  stubType2List.push(...option3);
                }
                this.setState(
                  {
                    typeOption: [...stubType2List],
                  },
                  () => {
                    this.setState({
                      formConfig: this.initForm(),
                    });
                  },
                );
              },
            },
            {
              type: "select",
              width: "95px",
              dropdownMatchSelectWidth: dropdownMatchSelectWidth,
              placeholder: this.internationalization.title8, // '请选择',
              param: {
                name: "operationMode",
                type: "string",
              },
              labelName: "",
              options: this.state.typeOption,
              required: false,
            },
          ],
        },
        {
          type: "date",
          dateType: "pickDate",
          placeholder: "年/月/日",
          param: {
            name: "date",
            type: "object",
          },
          disabledDate: (current) => {
            if (current < moment(new Date()).subtract(8, "d")) {
              return current < moment(new Date()).subtract(8, "d");
            }
            return current && current > moment(new Date()).subtract(1, "d");
          },
          allowClear: false,
          defaultValue: moment(new Date()).subtract(1, "d"),
          validator: {
            // 日期自定义校验规则
            vtype: "date", // 校验名称
            min_val: 0, // 可选最小天数
          }, // 自定义校验规则
          labelName: "查询时间",
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "button",
              message: "环比:数据与前一天比较",
              text: "查询",
              // icon: "search",
              handler: (e, param) => {
                // 设置城市数组
                let cityIds = "";
                if (param.cityGroup) {
                  param.cityGroup.map((item) => {
                    cityIds += `${item},`;
                    return true;
                  });
                }
                // 判断选择地区类型（全国、省份、城市）
                let cityType = "0"; // 0：全国，1：省份，2：城市
                if (param.cityGroup !== undefined) {
                  if (param.cityGroup.length === 0) {
                    cityType = "0";
                    cityIds = "000000";
                  } else if (param.cityGroup[0] === "000000") {
                    cityType = "0";
                  } else if (
                    param.cityGroup[0].charAt(5) === '0'
                    && param.cityGroup[0].charAt(4) === '0'
                    && param.cityGroup[0].charAt(3) === '0'
                    && param.cityGroup[0].charAt(2) === '0'
                  ) {
                    cityType = "1";
                  } else {
                    cityType = "2";
                  }
                }
                this.setState(
                  {
                    param: {
                      cityIds: cityType === "2" ? (cityIds || "") : "",
                      provinceIds: cityType === "0" || cityType === "1" ? (cityIds || "000000") : "",
                      date: param.date,
                      operationProperty: param.operationProperty ? param.operationProperty : "",
                      operationMode: param.operationMode ? param.operationMode : "",
                    },
                  },
                  () => {
                    console.log(this.state.param);
                    // 查询设备数据
                    this.getEquipmentQry();
                  },
                );
              },
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      defaultParams: {},
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      tableKey: "oprationLogTable",
    };

    return formConfig;
  }

  // style={{ "min-width": "1440px" }}
  render() {
    const content = (
      <div className='sc-page-content display-board-page'>
        <div className='page-toolbar'>
          <FormCore formConfig={this.state.formConfig} />
        </div>
        <div className='page-panel'>
          <div className='display-board'>
            <div className='item'>
              <div className='inner' style={{ padding: "24px 2%" }}>
                <div
                  className='fixed-more'
                  onClick={() => {
                    this.openTab(
                      {},
                      {
                        key: "0101",
                        titleText: "电站列表",
                      },
                    );
                  }}>
                  {" "}
                  详情
                  <RightOutlined />
                </div>
                <div className='detail-info stub-info-board'>
                  <div className='icon-part color1'>
                    <img alt="" src={icon1} className='info-img' />
                  </div>
                  <div className='stub-info-item'>
                    <div className='name'>
                      电站(个){" "}
                      <Tooltip
                        title={() => <span style={{ color: "#000" }}>电站为实时数据，不随选择日期变化</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <div className='num'>{this.state.equipmentQry.station}</div>
                  </div>
                </div>
              </div>
              <div className='inner' style={{ padding: "24px 2%" }}>
                <div
                  className='fixed-more'
                  onClick={() => {
                    this.openTab(
                      {},
                      {
                        key: "0104",
                        titleText: "配电柜管理",
                      },
                    );
                  }}>
                  {" "}
                  详情
                  <RightOutlined />
                </div>
                <div className='detail-info stub-info-board'>
                  <div className='icon-part color2'>
                    <img alt="" src={icon2} className='info-img' />
                  </div>
                  <div className='stub-info-item'>
                    <div className='name'>
                      配电柜(台)
                      <Tooltip
                        title={() => <span style={{ color: "#000" }}>配电柜为实时数据，不随选择日期变化</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <div className='num'>{this.state.equipmentQry.powerBox}</div>
                  </div>
                </div>
              </div>
              <div className='inner' style={{ padding: "24px 2%" }}>
                <div
                  className='fixed-more'
                  onClick={() => {
                    this.openTab(
                      {},
                      {
                        key: "0102",
                        titleText: "设备快速查询",
                      },
                    );
                  }}>
                  {" "}
                  详情
                  <RightOutlined />
                </div>
                <div className='detail-info stub-info-board'>
                  <div className='icon-part color3'>
                    <img alt="" src={icon3} className='info-img' />
                  </div>
                  <div className='stub-info-item'>
                    <div className='name'>
                      设备(台)
                      <Tooltip
                        title={() => <span style={{ color: "#000" }}>设备为实时数据，不随选择日期变化</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip>
                    </div>
                    <div className='num'>{this.state.equipmentQry.stub}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className='item'>
              <div className='inner progress-inner'>
                <div className='detail-info rate-num-board progress-inner'>
                  <div className='left-part'>
                    <div className='ratenum'>{this.state.stubIntactRate}%</div>
                    <div className='text-tit'>设备完好率</div>
                  </div>
                  <div className='progress color1'>
                    <Progress percent={parseInt(this.state.stubIntactRate)} showInfo={false} strokeColor='#3AA0FF' />
                  </div>
                </div>
              </div>
              <div className='inner progress-inner'>
                <div className='detail-info rate-num-board progress-inner'>
                  <div className='left-part'>
                    <div className='ratenum'>{this.state.successRate}%</div>
                    <div className='text-tit'>充电成功率</div>
                  </div>
                  <div className='progress color1'>
                    <Progress percent={parseInt(this.state.successRate)} showInfo={false} strokeColor='#75DDB2' />
                  </div>
                </div>
              </div>
            </div>
            <div className='item'>
              <div className='inner' style={{ height: "621px" }}>
                <div className='title'>
                  <div className='title-name'>设备状态</div>
                  <div
                    className='title-more'
                    onClick={() => {
                      this.openTab(
                        {},
                        {
                          key: "030101",
                          titleText: "设备完好率",
                        },
                      );
                    }}>
                    {" "}
                    详情
                    <RightOutlined />{" "}
                  </div>
                </div>
                <div>
                  <StubState getStubIntactRate={this.getStubIntactRate} param={this.state.param} />
                </div>
              </div>
            </div>
            <div className='item'>
              <div className='inner' style={{ height: "621px", display: "flex", flexDirection: "column" }}>
                <div className='title'>
                  <div className='title-name'>充电数据</div>
                  <div
                    className='title-more'
                    onClick={() => {
                      this.openTab(
                        {},
                        {
                          key: "030102",
                          titleText: "充电成功率",
                        },
                      );
                    }}>
                    {" "}
                    详情
                    <RightOutlined />{" "}
                  </div>
                </div>
                <div style={{ flex: 1 }}>
                  <ChargSuccess getSuccessRate={this.getSuccessRate} param={this.state.param} />
                </div>
              </div>
            </div>
            <div className='item'>
              <div className='inner' style={{ height: "621px" }}>
                <div className='title'>
                  <div className='title-name'>
                    电损数据{" "}
                    <Popover
                      content={
                        <div>
                          <p>电损数据，单位说明</p>
                          <p>K=10的3次方,千</p>
                          <p>M=10的6次方，百万</p>
                          <p>B=10的9次方，十亿</p>
                          <p>T=10的12次方，万亿</p>
                        </div>
                      }>
                      <QuestionCircleOutlined style={{ marginLeft: "10px", color: "#999" }} />
                    </Popover>
                  </div>
                  <div
                    className='title-more'
                    onClick={() => {
                      this.openTab(
                        {
                          date: [moment().subtract(7, "d"), moment()],
                        },
                        {
                          key: "030103",
                          titleText: "电损",
                        },
                      );
                    }}>
                    {" "}
                    详情
                    <RightOutlined />{" "}
                  </div>
                </div>
                <div>
                  <ElecticalLossBoard param={this.state.param} />
                </div>
              </div>
            </div>
            <div className='item'>
              <div className='inner' style={{ height: "621px" }}>
                <div className='title'>
                  <div className='title-name'>告警统计</div>
                </div>
                <div>
                  <ExceptionBoard param={this.state.param} onAdd={this.openTab} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
    return content;
  }
}

export default injectIntl(DisplayBoardIndex);



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/displayBoardIndex.js